import type { EnvIds } from '../store/envIds.store';
import { $envIds } from '../store/envIds.store';

export function getEnvIds(): EnvIds {
  return $envIds.getState();
}
